import { StandardEvents } from '@shopify/events';

/**
 * Keeps the "Save X%" pill (blocks/custom-price-savings.liquid) in sync with the
 * selected variant. Mirrors Horizon's own <product-price>: listen for the
 * product-select event on the section, wait for the re-rendered HTML, then copy
 * this block's new markup across.
 */
class PriceSavings extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /** @param {Event & { promise?: Promise<{ detail?: { html?: Document } }> }} event */
  #handleProductSelect = (event) => {
    // Swatch changes inside product cards are not ours to handle.
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const next = detail?.html?.querySelector(`price-savings[data-block-id="${this.dataset.blockId}"]`);
        if (next) this.innerHTML = next.innerHTML;
      })
      .catch(() => {});
  };
}

if (!customElements.get('price-savings')) {
  customElements.define('price-savings', PriceSavings);
}
